import { Box, Typography } from "@mui/material";
import React from "react";
import { useTheme as useAppTheme } from "../../context/ThemeContext";

export default function NoData({ lable, overlay = true }) {
  const { currentTheme } = useAppTheme();
  const palette = currentTheme?.palette || {};
  const textSecondary = palette.text?.secondary || "var(--text-secondary, #B0B0B0)";

  return (
    <Box
      sx={{
        ...(overlay
          ? {
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              margin: "auto",
              pointerEvents: "none",
            }
          : {
              py: 3,
            }),
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        width: "100%",
      }}
    >
      <Typography sx={{ color: textSecondary }}>{lable}</Typography>
    </Box>
  );
}
